export default "__VITE_PUBLIC_ASSET__62e34a78__"